export const toApiTruthy = (value: string | boolean | undefined): '0' | '1' => {
  if (value === '1' || value === true) {
    return '1';
  }
  return '0';
};
